import { j as l } from "./jsx-runtime-944c88e2.js";
import { Icon as o } from "@chakra-ui/react";
const i = (t) => /* @__PURE__ */ l.jsx(o, { xmlns: "http://www.w3.org/2000/svg", width: "24px", height: "24px", fill: "none", ...t, children: /* @__PURE__ */ l.jsx(
  "path",
  {
    fill: "#000",
    d: "M19.018 4.315a3.331 3.331 0 0 0-2.373-.982 3.33 3.33 0 0 0-2.372.982l-9.507 9.507s0 .003-.003.003a1.063 1.063 0 0 0-.217.385l-1.188 4.753a.831.831 0 0 0 .22.79l.001.002c.207.207.507.291.791.22l4.753-1.189c.136-.035.317-.15.385-.217l.003-.003 9.507-9.506A3.33 3.33 0 0 0 20 6.688c0-.896-.348-1.739-.982-2.373Zm-5.342 2.958 2.386 2.386-7.14 7.14-2.386-2.386 7.14-7.14ZM5.313 18.02l.495-1.978 1.484 1.484-1.98.494ZM17.84 5.494c.637.638.637 1.75 0 2.387l-.6.6-2.388-2.387.601-.6c.638-.636 1.75-.637 2.387 0Z"
  }
) });
export {
  i as T
};
